"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decoder = exports.encoder = void 0;
const Encoder_1 = require("./Encoder");
const Decoder_1 = require("./Decoder");
exports.encoder = new Encoder_1.Encoder();
exports.decoder = new Decoder_1.Decoder();
